import {
	mdiAccountSearchOutline,
	mdiAccountSupervisor,
	mdiAccountTie,
	mdiAccountVoice,
	mdiArchive,
	mdiBellOutline,
	mdiBriefcaseAccountOutline,
	mdiCash,
	mdiClockOutline,
	mdiDomain,
	mdiFactory,
	mdiFileOutline,
	mdiFileTableBoxMultiple,
	mdiFirework,
	mdiFolderAccountOutline,
	mdiHeadCogOutline,
	mdiHome,
	mdiHours24,
	mdiLaptop,
	mdiLinkedin,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiSchool,
	mdiTranslate,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'jobs-dashboard',
	},
	{
		title: 'application',
		icon: mdiFileTableBoxMultiple,
		module: 'MGJ,application',
		children: [
			{
				title: 'method',
				to: 'jobs-application-method-list',
			},
			{
				title: 'Status',
				to: 'jobs-application-status-list',
			},
		],
	},
	{
		icon: mdiFirework,
		title: 'companyPerks',
		to: 'jobs-perks-list',
		module: 'MGJ,company-perks',
	},
	{
		icon: mdiSchool,
		title: 'educationLevels',
		to: 'jobs-education-levels-list',
		module: 'MGJ,education-levels',
	},
	{
		title: 'menu.jobs.employment.employment',
		icon: mdiLaptop,
		module: 'MGJ,employment',
		children: [
			{
				title: 'menu.jobs.employment.employmentType',
				to: 'jobs-employments-types-list',
			},
		],
	},
	{
		icon: mdiFolderAccountOutline,
		title: 'menu.jobs.experiences',
		to: 'jobs-experiences-list',
		module: 'MGJ,experiences',
	},
	{
		icon: mdiFactory,
		title: 'menu.jobs.industrySectors',
		to: 'industry-sector-categories-list',
	},
	{
		icon: mdiBriefcaseAccountOutline,
		title: 'menu.jobs.gigs',
		module: 'MGJ,gigs',
		children: [
			{
				title: 'menu.jobs.gigCategories',
				to: 'jobs-gig-categories-list',
			},
			{
				title: 'menu.jobs.gigListings',
				to: 'jobs-gig-listings-list',
			},
			{
				title: 'menu.jobs.gigNegotiations',
				to: 'jobs-gig-negotiations-list',
			},
			{
				title: 'menu.jobs.gigProposalPayouts',
				to: 'jobs-gig-proposal-payouts-list',
			},
			{
				title: 'menu.jobs.gigDisputes',
				to: 'jobs-gig-disputes-list',
			},
			{
				title: 'menu.jobs.gigReviewContests',
				to: 'jobs-gig-review-contests-list',
			},
			{
				title: 'menu.jobs.gigSocialBoosts',
				to: 'jobs-gig-social-boosts-list',
			},
		],
	},

	{
		icon: mdiTranslate,
		title: 'languageLevels',
		to: 'jobs-language-levels-list',
	},
	{
		icon: mdiAccountSupervisor,
		title: 'mentorshipRecruitmentStatus',
		to: 'jobs-mentorship-recruitment-status-list',
	},
	{
		icon: mdiAccountTie,
		title: 'menu.jobs.professionalSituations',
		to: 'jobs-professional-situations-list',
	},
	{
		icon: mdiFileOutline,
		title: 'menu.jobs.resumes',
		to: 'jobs-resumes-list',
		module: 'MGJ,resumes',
	},
	{
		icon: mdiAccountVoice,
		title: 'menu.jobs.requests',
		to: 'jobs-requests-list',
	},
	{
		icon: mdiAccountSearchOutline,
		title: 'menu.jobs.selectionProcesses',
		to: 'jobs-selection-processes-list',
		module: 'MGJ,selection-processes',
	},
	{
		title: 'menu.jobs.salary',
		icon: mdiCash,
		module: 'MGJ,salary',
		children: [
			{
				title: 'menu.jobs.salarySource',
				to: 'jobs-salary-source-types-list',
			},
			{
				title: 'menu.jobs.salarySubmissions',
				to: 'jobs-salary-submissions-list',
			},
			{
				title: 'menu.jobs.salaryInsightTextCategories',
				to: 'jobs-salary-insight-text-categories-list',
			},
			{
				title: 'menu.jobs.salaryInsightTexts',
				to: 'jobs-salary-insight-texts-list',
			},
			{
				title: 'menu.jobs.salaryTaxRates',
				to: 'jobs-salary-tax-rates-list',
			},
		],
	},
	{
		title: 'menu.jobs.vacancies',
		icon: mdiBriefcaseAccountOutline,
		module: 'MGJ,vacancies',
		children: [
			{
				title: 'menu.jobs.vacanciesDrop.list',
				to: 'jobs-vacancies-list',
			},
			{
				title: 'menu.jobs.vacancyTitle',
				to: 'jobs-vacancy-titles-list',
			},
			{
				title: 'Status',
				to: 'jobs-vacancies-status-list',
			},
			{
				title: 'menu.jobs.vacanciesDrop.applications',
				to: 'jobs-applications-list',
			},
			{
				title: 'menu.jobs.vacanciesDrop.urlChecker',
				to: 'jobs-url-checker-list',
			},
			{
				title: 'Sugestões automáticas',
				to: 'jobs-gaming-job-suggestions',
			},
		],
	},
	{
		icon: mdiDomain,
		title: 'menu.institutions',
		to: 'institutions',
	},
	{
		title: 'widgets',
		icon: mdiFileTableBoxMultiple,
		module: 'MGJ,widgets',
		children: [
			{
				title: 'widgetFormat',
				to: 'jobs-widget-format-list',
			},
			{
				title: 'widgets',
				to: 'jobs-widgets-list',
			},
		],
	},
	{
		icon: mdiHours24,
		title: 'menu.jobs.workAvailabilities',
		to: 'jobs-work-availabilities-list',
	},
	{
		icon: mdiClockOutline,
		title: 'menu.jobs.workHours',
		to: 'jobs-work-hours-list',
	},
	{
		icon: mdiArchive,
		title: 'menu.jobs.workMethodologies',
		to: 'jobs-work-methodologies-list',
	},
	{
		title: 'Testes de Personalidade',
		icon: mdiHeadCogOutline,
		module: 'MGJ,personality-tests',
		children: [
			{
				title: 'Testes',
				to: 'jobs-personality-tests-list',
			},
			{
				title: 'Sessões',
				to: 'jobs-personality-tests-sessions',
			},
			{
				title: 'Resultados',
				to: 'jobs-personality-tests-results',
			},
			{
				title: 'Convites',
				to: 'jobs-personality-tests-assignments',
			},
			{
				title: 'Nurture (Leads)',
				to: 'jobs-personality-tests-nurture',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'jobs-messages-list',
		module: 'MGJ,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'jobs-newsletter-list',
		module: 'MGJ,newsletter',
	},
	{
		icon: mdiAccountTie,
		title: 'jobs.recruiterProspects.title',
		to: 'jobs-recruiter-prospects-list',
		module: 'MGJ,recruiter-prospects',
	},
	{
		icon: mdiLinkedin,
		title: 'jobs.linkedinNewsletter.list.title',
		module: 'MGJ,linkedin-newsletter',
		children: [
			{
				title: 'jobs.linkedinNewsletter.list.title',
				to: 'jobs-linkedin-newsletter-list',
			},
			{
				title: 'jobs.linkedinNewsletter.list.configure',
				to: 'jobs-linkedin-newsletter-config',
			},
		],
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGJ,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'jobs-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
